import React from 'react';

export default function WhereShouldILive(props?: any) {
    return <div>
            <iframe src={"./where_should_I_live/index.html"} style={{borderStyle:"none",width:"100%",height:"2200px"}}></iframe>
    </div>
}